
import { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import * as React from 'react';

export default function MaintenanceWrapper({ children }: { children: React.ReactNode }) {
    const [maintenanceMode, setMaintenanceMode] = useState(false);
    const [location] = useLocation();

    // Owner-only push trigger check
    useEffect(() => {
        // Helper for owner to turn OFF maintenance locally via URL ?maintenance=false
        const urlParams = new URLSearchParams(window.location.search);
        // Vite uses import.meta.env instead of process.env
        // Ensure we handle the type properly (string | undefined)
        const envMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

        // Allow URL override for testing even if Env is false
        const isMaintenance = urlParams.get('maintenance') === 'true' || envMode;

        if (urlParams.get('maintenance') === 'false') {
            setMaintenanceMode(false);
        } else {
            setMaintenanceMode(isMaintenance);
        }
    }, []);

    const sendOwnerAlert = async () => {
        if ('serviceWorker' in navigator) {
            if (Notification.permission === 'default') {
                await Notification.requestPermission();
            }

            if (Notification.permission === 'granted') {
                const registration = await navigator.serviceWorker.ready;
                if (registration) {
                    registration.showNotification('🟢 SUPABASE UP!', {
                        body: 'Database weer online. Deploy maintenanceMode=false!',
                        // icon: '/pwa-192x192.png', // Ensure these exist or use empty string
                        // badge: '/pwa-192x192.png',
                        tag: 'maintenance-alert',
                        // actions: [{ action: 'deploy', title: 'Deploy Fix' }]
                    });
                    alert("PWA Alert verzonden! Check je notificaties.");
                } else {
                    alert("Geen actieve Service Worker gevonden.");
                }
            } else {
                alert("Notificaties niet toegestaan.");
            }
        } else {
            alert("Service Workers niet ondersteund.");
        }
    };


    // Always render children, but overlay if maintenance mode is active
    return (
        <>
            {children}

            {/* OWNER DASHBOARD BUTTON (alleen zichtbaar op /backoffice routes) */}
            {location.includes('/backoffice') && (
                <button
                    onClick={sendOwnerAlert}
                    className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 z-[99999] animate-pulse border-4 border-white cursor-pointer transition-all hover:scale-110 flex items-center justify-center w-[60px] h-[60px] text-2xl"
                    title="Stuur jezelf PWA alert: 'Supabase UP!'"
                >
                    🚀
                </button>
            )}

            {/* MAINTENANCE POPUP OVERLAY */}
            {maintenanceMode && (
                <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-[99998] p-4 animate-in fade-in duration-300">
                    <div className="bg-background/95 backdrop-blur-xl rounded-2xl p-8 max-w-md w-full shadow-2xl border border-border text-center">
                        <div className="text-6xl mb-6 animate-bounce mx-auto">⚠️</div>
                        <h2 className="text-2xl font-bold text-foreground mb-4">
                            Service onderbreking
                        </h2>
                        <p className="text-muted-foreground mb-6 leading-relaxed">
                            We ervaren momenteel database problemen bij onze provider (Supabase). Ons team is op de hoogte en werkt aan een oplossing.
                        </p>
                        <div className="bg-destructive/10 text-destructive border border-destructive/20 px-4 py-2 rounded-full font-semibold mb-6 animate-pulse inline-block">
                            STATUS: OFFLINE
                        </div>
                        <p className="text-xs text-muted-foreground mb-6">
                            Laatste update: {new Date().toLocaleString('nl-NL')}
                        </p>

                        {/* Secret bypass button for owner (hidden functionality) */}
                        <Button
                            variant="default"
                            onClick={() => setMaintenanceMode(false)}
                            className="w-full font-semibold py-6 text-lg"
                        >
                            Ik begrijp het (tijdelijk verbergen)
                        </Button>
                    </div>

                    <style>{`
            body { overflow: hidden; }
          `}</style>
                </div>
            )}
        </>
    );
}
